import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { Money } from '../../../core/model/money';
import { KU55Content } from './ku55-content';

export class ControlDataForm extends ModelBase {
  contact: string;
  formNumber: number;
  comment: string;
  kU55Content: KU55Content;
  validationMessage: string;
}
